import styled from "styled-components";

export const MailSocials = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  gap: 20px;
  width: 383px;
  @media (max-width: 64em) {
    width: 100%;
  }
`;
